import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";




@Injectable({
    providedIn: "root",
  })
  export class RoleService {
    constructor(
        private authService : AuthService
    ){}

    isAllowedToAccess(roles : string[]) : boolean {
        const userRole  = this.authService.role;

        if (roles.length == 0) return true
        return roles.includes(userRole)
    }

    disableForRoles(roles : string[]) : boolean{
      const userRole = this.authService.role;
      if (roles.length == 0) return true
      return roles.includes(userRole)
    }

  }
